import { styled } from '@linaria/react';

import Aside from '@/components/Aside';
import InlineCode from '@/components/InlineCode';
import Paragraph from '@/components/Paragraph';

function NoInterpolateSize() {
  return (
    <BrowserAside type="warning" title="Unsupported browser detected">
      <Paragraph>
        The <InlineCode>interpolate-size</InlineCode> property is not
        yet supported in your browser. Unfortunately, this means you
        won’t see the smooth animation in the above playground.
      </Paragraph>

      <Paragraph>We’ll discuss browser support shortly.</Paragraph>
    </BrowserAside>
  );
}

const BrowserAside = styled(Aside)`
  @supports (interpolate-size: allow-keywords) {
    display: none;
  }
`;

export default NoInterpolateSize;
